import Axios from 'axios';
import {urlAPIDirectus} from "../config/Globals";

function findAllInRubrique(rubriqueId){
    return Axios
        .get(urlAPIDirectus+"Article?filter[status][_eq]=published&fields=*.*&filter[id_rubrique][_eq]="+rubriqueId)
        .then(response => response.data.data);
}

function find(id){
    return Axios
        .get(urlAPIDirectus+"Article/"+id+"?filter[status][_eq]=published")
        .then(response => response.data.data);
}
function search(search){
    return Axios
        .get(urlAPIDirectus+"Article?filter[status][_eq]=published&filter[_or][0][titre][_icontains]="+search+"&filter[_or][1][contenu][_icontains]="+search+'&fields=*.*')
        .then(response => response.data.data);
}
export default {
    findAllInRubrique,find,search
}